import { render, staticRenderFns } from "./envelope-delete-modal.vue?vue&type=template&id=467734ce&scoped=true"
import script from "./envelope-delete-modal.vue?vue&type=script&lang=js"
export * from "./envelope-delete-modal.vue?vue&type=script&lang=js"
import style0 from "./envelope-delete-modal.vue?vue&type=style&index=0&id=467734ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467734ce",
  null
  
)

export default component.exports